// Fallback to process.env (for server.js or local dev)
const getEnv = (key, defaultValue) => {
    if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
        return window._env_[key];
    }
    return process.env[key] || defaultValue;
};

// Default configs
const DEFAULT_BASE_URL = 'https://htcr-uat.ncsa.or.th/';
const DEFAULT_API_URL = 'https://htcr-uat.ncsa.or.th/ws/api/';
const DEFAULT_FILE_UPLOAD_URL = 'https://htcr-uat.ncsa.or.th/ws/FileUpload/';
const DEFAULT_PHP_URL = 'https://htcr.ncsa.or.th/sm/';

const Config = {
    baseUrl: getEnv('REACT_APP_BASE_URL', DEFAULT_BASE_URL),
    apiUrl: getEnv('REACT_APP_API_URL', DEFAULT_API_URL),
    fileUpload: getEnv('REACT_APP_FILE_UPLOAD_URL', DEFAULT_FILE_UPLOAD_URL),
    phpUrl: getEnv('REACT_APP_PHP_URL', DEFAULT_PHP_URL),
};

module.exports = {
    Config: Config
};